import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, Button, Row, Col } from "antd";
import { SaveOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { find, filter } from 'lodash';

import {
    loadAppResource, saveAppResource
} from '../actions';

import common from '../../../common';
import currentuser from '../../currentuser';
import uistate from '../../uistate';
import globalappstate from '../../globalappstate';

const Option = Select.Option;
const modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ size: [] }],
        [{ font: [] }],
        [{ align: ["right", "center", "justify"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        [{ color: ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0091dc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'] }]
    ]
};

const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font"
];
class EditStartScreen extends Component {

    state = {
        editorState: '',
        resource: {},
        lang: 0,
    }

    handleChange = (editorState) => {
        this.setState({ editorState })
        //this.props.setFieldValue(this.props.name, editorState.toHTML())
    }
    handleChangeLanguage = async (value) => {
        const resp = await this.props.loadAppResource(value, 'StartScreen');
        this.setState({
            editorState: resp.data.value || '',
            resource: resp.data,
            lang: parseInt(value)
        })
    }
    onSaveClicked = async () => {
        if (this.state.lang > 0) {
            let res = { ...this.state.resource };
            res.value = this.state.editorState;
            await this.props.saveAppResource(this.state.lang, 'StartScreen', res);
            this.handleChangeLanguage(this.state.lang);
        }
    }
    render() {
        return (
            <div className='startscreen'>
                <Row align="middle" >
                    <Col>
                        <Select showSearch optionFilterProp="children" filterOption={true} style={{ width: 250 }}
                            placeholder='Select language / selecteer taal'
                            onChange={value => this.handleChangeLanguage(value)}
                        >
                            <Option key="1033" value="1033">EN</Option>
                            <Option key="1043" value="1043">NL</Option>
                        </Select>
                    </Col>
                    <Col>
                        <Button style={{ margin: 15 }} type="primary" onClick={() => { this.onSaveClicked() }} icon={<SaveOutlined />} >Save</Button>
                    </Col>
                </Row>
                <ReactQuill
                    theme="snow"
                    value={this.state.editorState}
                    onChange={this.handleChange}
                    modules={modules}
                    formats={formats}
                />
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        uistate: state[uistate.constants.NAME],
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        loadAppResource, saveAppResource
    })(EditStartScreen);
